import { SendPlatform } from 'app/enums';
import { REGEX_PATTERNS, VALIDATION_MESSAGES } from 'app/validation/validation';
import { isMobileDevice } from 'app/functions';


export const shareViaEmail = (url, emailTitle = 'שיתוף קישור') => {
    const mailtoUrl = `mailto:?subject=${encodeURIComponent(emailTitle)}&body=${encodeURIComponent(url)}`;
    const isMobile = isMobileDevice();
    
    if (isMobile) {
        window.location.href = mailtoUrl;
    } else {
        window.open(mailtoUrl, '_blank');
    }
};

export const shareViaSMS = (url) => {
    const smsUrl = `sms:?body=${encodeURIComponent(url)}`;
    const isMobile = isMobileDevice();
    
    if (isMobile) {
        window.location.href = smsUrl;
    } else {
        window.open(smsUrl, '_blank');
    }
};

export const shareViaWhatsApp = (url, phone) => {
    let cleanPhone = phone.trim().replace(/[\s\-\(\)]/g, '');
    
    if (cleanPhone.startsWith('0')) {
        cleanPhone = '972' + cleanPhone.substring(1);
    } else if (!cleanPhone.startsWith('972')) {
        cleanPhone = '972' + cleanPhone;
    }
    const whatsappUrl = `https://wa.me/${cleanPhone}?text=${encodeURIComponent(url)}`;
    
    const isMobile = isMobileDevice();
    
    if (isMobile) {
        const link = document.createElement('a');
        link.href = whatsappUrl;
        link.setAttribute('data-action', 'share/whatsapp/share');
        link.setAttribute('rel', 'noopener noreferrer');
        link.setAttribute('target', '_blank');
        link.style.display = 'none';
        document.body.appendChild(link);
        
        requestAnimationFrame(() => {
            link.click();
            setTimeout(() => {
                document.body.removeChild(link);
            }, 100);
        });
    } else {
        window.open(whatsappUrl, '_blank');
    }
};

export const shareViaNativeShare = async (url, text = null, title = null) => {
    if (navigator.share) {
        try {
            const shareData = {};
            if (text) {
                shareData.text = text;
                if (url && !text.includes(url)) {
                    shareData.text = text + '\n\n' + url;
                }
            } else if (url) {
                shareData.url = url;
            }
            if (title) shareData.title = title;
            await navigator.share(shareData);
            return true;
        } catch (err) {
            if (err.name !== 'AbortError') {
                return false;
            }
        }
    }
    return false;
};

export const extractEmailTitle = (popupContent) => {
    if (!popupContent?.title) return 'שיתוף קישור';
    return popupContent.title.replace(/<[^>]*>/g, '');
};

export const copyToClipboard = async (text) => {
    try {
        await navigator.clipboard.writeText(text);
        return true;
    } catch (err) {
        return copyToClipboardFallback(text);
    }
};

const copyToClipboardFallback = (text) => {
    try {
        const textArea = document.createElement('textarea');
        textArea.value = text;
        textArea.style.position = 'fixed';
        textArea.style.opacity = '0';
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
        return true;
    } catch (err) {
        console.error('Failed to copy:', err);
        return false;
    }
};

export const validatePhoneNumber = (phoneValue) => {
    if (!phoneValue) {
        return { valid: false, error: VALIDATION_MESSAGES.REQUIRED };
    }
    
    if (!REGEX_PATTERNS.CELL.test(phoneValue.trim())) {
        return { valid: false, error: VALIDATION_MESSAGES.CELL };
    }
    
    return { valid: true, error: '' };
};

